import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { Box } from '@mui/material';
import styled from 'styled-components';
import { Typography } from '../typography';
import { Button } from '../button';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { Chip } from '../chip';
import { i18n } from '../../i18n';
import { useIsSmallScreen } from '../../hooks';

const OfferPayWrapper = styled.div``;
interface OfferPayModalType {
  data: {
    price: number;
  }[];
  submitClick: () => void;
  open: () => void;
}

export const offerPayModal: OfferPayModalType = {
  data: [],
  submitClick: () => null,
  open: () => null,
};

export const OfferPayModal = () => {
  const isSmallScreen = useIsSmallScreen();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    offerPayModal.open = () => {
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    offerPayModal.data = [];
    setOpen(!open);
  };

  const handleSubmitClick = async () => {
    setOpen(false);
    offerPayModal.submitClick();
  };

  return (
    <ModalBase
      id={'offer-pay-modal'}
      paperSize={isSmallScreen ? 'mobile' : 'default'}
      open={open}
      onClose={handleOnClose}
    >
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.offerPayTitle', {
            total: offerPayModal.data.reduce((acc, item) => acc + Number(item.price), 0),
          })}
        </Typography>
        <OfferPayWrapper>
          <Typography variant={'textM'}>
            <Trans
              i18nKey={'pages.modal.offerPayContent'}
              components={{
                chip: (
                  <Box component="span" display="inline-flex">
                    <Chip label="+998 (99) 760-42-42" color="blue" component={'span'} />
                  </Box>
                ),
              }}
            />
          </Typography>
        </OfferPayWrapper>
        <ModalFooterButtons>
          <Button size={'medium'} onClick={handleSubmitClick}>
            {i18n.t('button.ok')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
